export const fetchHotels = async () => {


    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;

    
    try {
        const response = await fetch(`${apiUrl}/api/hotels`, {
            headers: { 'Authorization': `Bearer ${token}`}, // Attach the token here
        });
        if (!response.ok) {
            throw new Error('Failed to fetch hotels');
        }

        const data = await response.json();

        console.log("dataaaaaaaaaaaaaa",data);
        return data; // Return the hotel data
    } catch (error) {
        console.error('Error fetching hotels:', error);
        throw error; // Rethrow error to handle it in the component
    }
};
